import { Component, type ErrorInfo, type ReactNode } from 'react';
import { translate, type Locale } from '@/i18n';

interface Props { children: ReactNode }
interface State { failed: boolean }

/** Last line of defence: a runtime error shows a calm message and a reload, never a blank page. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled render error', error, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const locale = (document.documentElement.lang === 'hi' ? 'hi' : 'en') as Locale;
    return (
      <main id="main" className="mx-auto max-w-narrow px-4 py-16 text-center">
        <h1 className="mb-4">{translate(locale, 'common.error')}</h1>
        <button type="button" className="min-h-btn rounded-md bg-teal-600 px-5 text-label text-white" onClick={() => window.location.reload()}>
          {translate(locale, 'common.reload')}
        </button>
      </main>
    );
  }
}
